import {
	SEARCH_LOAD_STORAGE,
	SEARCH_LOAD_ALL_STORAGE_SEARCHS,
	REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS,
	SAVED_SEARCH_LOAD_ALL,
	DELETE_SEARCH_LOAD,
	SAVE_NEW_SEARCH,
	SAVE_NEW_SEARCH_SUCCESS,
	SAVE_NEW_SEARCH_FAILED,
	SAVE_NEW_SEARCH_FAILED_CLEAR,
	DELETE_SEARCH_SUCCESS,
	DELETE_SEARCH_FAILED,
	DELETE_SEARCH_RESET,
} from "../types"

export const setSearchLoad = (searchReducer) => ({
	type: SEARCH_LOAD_STORAGE,
	payload: searchReducer,
})

export const saveInitSearchSagas = () => ({
	type: REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS,
})

export const savedSearchLoadAll = () => ({
	type: SAVED_SEARCH_LOAD_ALL,
})

export const deleteSearchLoad = (idSearch) => ({
	type: DELETE_SEARCH_LOAD,
	payload: {
		idSearch: idSearch,
	},
})

export const deleteSearchSuccess = (data) => ({
	type: DELETE_SEARCH_SUCCESS,
	payload: data,
})

export const deleteSearchFailed = (data) => ({
	type: DELETE_SEARCH_FAILED,
	payload: data,
})

export const deleteSearchReset = () => ({
	type: DELETE_SEARCH_RESET,
})

export const saveNewSearch = (newSearch) => ({
	type: SAVE_NEW_SEARCH,
	payload: {
		newSearch: newSearch,
	},
})

export const saveNewSearchSuccess = (data) => ({
	type: SAVE_NEW_SEARCH_SUCCESS,
	payload: data,
})

export const saveNewSearchFailed = (data) => ({
	type: SAVE_NEW_SEARCH_FAILED,
	payload: data,
})

export const saveNewSearchFailedClear = () => ({
	type: SAVE_NEW_SEARCH_FAILED_CLEAR,
})
